<template>
  <div>
    <service-types-table/>
  </div>
</template>

<script>
import ServiceTypesTable from "@/components/app/service-types/ServiceTypesTable.vue";

export default {
  components: {
    ServiceTypesTable
  },
  name: "ServiceTypes"
}
</script>

<style scoped>

</style>
